module.exports = __webpack_public_path__ + "static/img/no2_bg.195277b1.png";